import Index from "../../pages/mitu/year/index";
import Pc from "../../pages/mitu/year/pc";

const base = "year";

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
  {
    path: `/${base}/pc*`,
    name: `${base}-pc`,
    component: Pc
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/mitu/year.js